import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import * as popper from '@popperjs/core';
import * as bootstrap from 'bootstrap';
import initPlayer from './components/player';

import initTextAnims from './components/text-anims';
import initTestimonials from './components/testimonials';
import initGallery from './components/gallery';
import initItemCards from './components/item-cards';
import initHero from './components/hero';
import initFeature from './components/feature';
import initHeader from './components/header';
import initRoomCard from './components/room-card';
import initRooms from './components/rooms';
import initOffers from './components/offers';
import initCrossSell from './components/cross-sell';
import initTimeline from './components/timeline';
import initBooking, { initGlobalBooking } from './components/booking';
import initArticles from './components/articles';



gsap.registerPlugin(ScrollTrigger);

// Styles
import '../scss/styles.scss';
import 'swiper/swiper-bundle.css';

// -----------------------------
// Lenis
// -----------------------------
const lenis = new Lenis({
  smoothWheel: true,
  duration: 1.2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
});
window.lenis = lenis;

// Keep ScrollTrigger in sync with Lenis' smooth-scrolled position.
// Without this, scrub-based animations (e.g. .feature__small) read the native
// scroll position while Lenis is smoothing it, causing jumpy/laggy motion.
lenis.on('scroll', ScrollTrigger.update);

// Drive Lenis from GSAP's ticker so both run on a single, shared loop.
gsap.ticker.add((time) => {
  lenis.raf(time * 1000); // GSAP ticker time is in seconds, Lenis expects ms
});
gsap.ticker.lagSmoothing(0);


// -----------------------------
// Helpers init
// -----------------------------
window.initTextAnims = initTextAnims;

function initPage() {
  // Pages

  // Text anims
  initTextAnims();

  // Components
  initHeader();
  initTestimonials();
  initGallery();
  initItemCards();
  initHero();
  initFeature();
  initRoomCard();
  initRooms();
  initOffers();
  initCrossSell();
  initTimeline();
  initBooking();
  initGlobalBooking();
  initArticles();
}


function afterPageMounted() {

  // Ensure Lenis knows the new content height
  lenis.resize();

  try {
    lenis.scrollTo(0, { immediate: true });
  } catch (e) {
    window.scrollTo(0, 0);
  }

  // Refresh ScrollTrigger to account for new page layout.
  ScrollTrigger.refresh();

  // DOMContentLoaded fires before images, video and web fonts have loaded.
  // Those assets shift the layout afterwards, leaving scrub trigger positions
  // stale — which makes scrubbed animations (e.g. .feature__small) snap/jump.
  // Re-measure once everything that affects layout has settled.
  window.addEventListener('load', () => ScrollTrigger.refresh());

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => ScrollTrigger.refresh());
  }

  const root = document.documentElement;
  function setVar() {
    const fc = document.querySelector('.footer .container');
    if (fc) root.style.setProperty('--container-width', fc.offsetWidth + 'px');
  }
  setVar();
  window.addEventListener('resize', setVar, { passive: true });
}

addEventListener("DOMContentLoaded", (event) => {
  // player
  initPlayer();

  initPage();
  afterPageMounted();

})
